import styled from 'styled-components';

export const Cart = styled.span`
  margin-left : 15px;
  cursor: pointer;
`;

export const StyledFont = styled.div`
font-family: AvenirLTStd-Book,Arial,Helvetica,sans-serif;
#deskMenuBottom {
    ul {
        li {
            a > p {
                box-sizing: unset;
            }
        }
    }
}
`;

